module.exports = __webpack_public_path__ + "static/media/whatsapp-off.d0dcd591.svg";